import React, { useState, useEffect, useRef } from "react";

const slides = Array.from({ length: 13 }, (_, index) => {
  const id = index + 1;
  return {
    id,
    image: `/slides/Slide${id}.webp`,
    alt: `Slide ${id}`,
  };
});

export default function Slides() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const trackRef = useRef(null);

  /* Auto-scroll */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((i) => (i + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  /* Scroll to active slide */
  useEffect(() => {
    if (!trackRef.current) return;
    const slide = trackRef.current.children[currentIndex];
    if (!slide) return;

    trackRef.current.scrollTo({
      left: slide.offsetLeft,
      behavior: "smooth",
    });
  }, [currentIndex]);

  return (
    <section className="relative bg-white pt-16 lg:pt-16 pb-[16px]">
      {/* Horizontal Line - Responsive */}
      <div className="relative w-full flex justify-center mb-[120px] sm:mb-[140px] md:mb-[167px]">
        <div className="w-[85%] sm:w-[75%] md:w-[680px] lg:w-[900px] xl:w-[1075px] max-w-[90%] h-px bg-black" />
      </div>

      {/* 1️⃣ VIEWPORT MASK (defines silhouette) */}
      <div className="overflow-hidden rounded-l-[32px] bg-white">
        {/* 2️⃣ LEFT OFFSET SPACER (never scrolls) */}
        <div
          className="
            relative
            px-[40px]
            md:px-[72px]
            xl:px-[144px]
          "
        >
          {/* HARD LEFT MASK (prevents bleed during motion) */}
          <div
            className="
              pointer-events-none
              absolute left-0 top-0 h-full
              w-[40px]
              md:w-[72px]
              xl:w-[144px]
              bg-white
              rounded-l-[32px]
              z-10
            "
            style={{ right: 0 }}
          />

          {/* 3️⃣ SCROLLING TRACK */}
          <div
            ref={trackRef}
            className="
              relative z-0
              flex gap-6 overflow-x-auto scrollbar-hide
              cursor-grab active:cursor-grabbing
            "
            style={{
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {slides.map((slide) => (
              <div
                key={slide.id}
                className="
                  flex-shrink-0
                  w-[317px] h-[302px]
                  lg:w-[764px] lg:h-[822px]
                  rounded-2xl
                  overflow-hidden
                  bg-neutral-100
                  shadow-lg
                "
              >
                <img
                  src={slide.image}
                  alt={slide.alt}
                  loading="lazy"
                  className="w-full h-full object-cover"
                  draggable="false"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Horizontal Line - Responsive (Bottom) */}
      <div className="mt-[120px] sm:mt-[140px] md:mt-[167px] relative w-full flex justify-center">
        <div className="w-[85%] sm:w-[75%] md:w-[680px] lg:w-[900px] xl:w-[1075px] max-w-[90%] h-px bg-black" />
      </div>
    </section>
  );
}
